// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Bp-z","zenCrossSiteLabel":"Cp-z","vrsnlCrossSiteLabel":"Dp-z"};